<template>
    <Teleport v-if="destinoDisponible" to="#page-header-actions" defer>
        <slot />
    </Teleport>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

const destinoDisponible = ref(false)

onMounted(() => {
    destinoDisponible.value = document.getElementById('page-header-actions') !== null
})
</script>
